module.exports = __webpack_public_path__ + "images/feb1a01d875c0c4a69b5bbbf3977c93d-iso-mark.png";